// extracted by mini-css-extract-plugin
export default {"testMobileLabel":"TestField_testMobileLabel__1LZzz","testName":"TestField_testName__ESKg0"};